// extracted by mini-css-extract-plugin
export default {"pile":"characterSymbol_pile__R477Y","symbol":"characterSymbol_symbol__EdfxQ","romaji":"characterSymbol_romaji__WvUbo","highlight":"characterSymbol_highlight__2nTXZ"};